import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { loginUser, logoutUser, fetchProfile } from '../store/slices/authSlice';

export const useAuth = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, isAuthenticated, loading, error } = useSelector((state) => state.auth);

  const login = async (email, password, recaptcha_token, redirectTo) => {
    const result = await dispatch(loginUser({ email, password, recaptcha_token }));
    if (loginUser.fulfilled.match(result)) {
      const u = result.payload?.user;
      if (u?.role === 'customer') {
        navigate(redirectTo || '/dashboard', { replace: !!redirectTo });
      } else {
        const rt = u?.reviewer_type;
        if (rt === 'maker')                   navigate('/admin/maker');
        else if (rt === 'checker')            navigate('/admin/checker');
        else if (rt === 'auditor')            navigate('/admin/audit-logs');
        else if (rt === 'disbursement_officer') navigate('/admin/disbursement');
        else if (rt === 'kyc_officer')          navigate('/admin/kyc-officer');
        else                                    navigate('/admin/dashboard');
      }
    }
    return result;
  };

  const logout = async () => {
    await dispatch(logoutUser());
    navigate('/login');
  };

  const loadProfile = useCallback(() => dispatch(fetchProfile()), [dispatch]);

  const reviewerType = user?.reviewer_type || null;

  return { user, isAuthenticated, loading, error, login, logout, loadProfile,
    isAdmin:                user?.role === 'admin',
    isStaff:                ['admin', 'staff'].includes(user?.role),
    reviewerType,
    isMaker:                ['maker', 'both'].includes(reviewerType),
    isChecker:              ['checker', 'both'].includes(reviewerType),
    isAuditor:              reviewerType === 'auditor',
    isDisbursementOfficer:  reviewerType === 'disbursement_officer',
    isKycOfficer:           reviewerType === 'kyc_officer',
  };
};
